import { DeliveryProvider } from '../../../../../services/exports/Constants';

export default {
  title: 'Verificar cobertura de endereço',
  or: 'ou',
  form: {
    company: {
      label: 'Selecionar restaurante',
    },
    address: {
      label: 'Introduza o endereço',
    },
  },
  result: {
    positive: '{{address}} é elegível para entrega externa',
    negative: '{{address}} não é elegível para entrega externa',
  },
  providers: {
    [DeliveryProvider.FirstDelivery]: 'Uber',
    [DeliveryProvider.UberDrive]: 'Uber',
    [DeliveryProvider.WoltDrive]: 'Wolt',
  },
  buttons: {
    check: 'Verificar',
  },
  toasts: {
    error: 'Erro ao verificar cobertura de endereço',
  },
};
